module.exports = __webpack_public_path__ + "img/logo.41f7f0a.png";